module.exports = __webpack_public_path__ + "static/media/downloadDark.a022e547.svg";